import React from 'react';


const STATUS_CONFIG = {
  nouveau: {
    label: 'Nouveau',
    icon: 'Clock',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-400',
  },
  instruction_en_cours: {
    label: 'Instruction en cours',
    icon: 'Search',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
    dot: 'bg-blue-500',
  },
  dossier_valide: {
    label: 'Dossier Validé',
    icon: 'CheckCircle',
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-200',
    dot: 'bg-green-500',
  },
  projet_acte_depose: {
    label: "Projet d\'acte déposé",
    icon: 'FileCheck',
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    border: 'border-purple-200',
    dot: 'bg-purple-500',
  },
  transaction_cloturee: {
    label: 'Transaction Clôturée',
    icon: 'CheckSquare',
    bg: 'bg-slate-50',
    text: 'text-slate-600',
    border: 'border-slate-200',
    dot: 'bg-slate-400',
  },
};

const DossierStatusBadge = ({ status, size = 'md' }) => {
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.nouveau;
  const isSmall = size === 'sm';

  return (
    <span className={`inline-flex items-center space-x-1.5 px-2.5 py-1 rounded-full border font-system font-body-medium ${config?.bg} ${config?.text} ${config?.border} ${isSmall ? 'text-[11px]' : 'text-ios-caption1'}`}>
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config?.dot}`} />
      <span>{config?.label}</span>
    </span>
  );
};

export { STATUS_CONFIG };
export default DossierStatusBadge;
